/*
 *   File : detail.js
 *   Author : https://evoqins.com
 *   Description : File to list all available documents in the selected customer's account. 
 *   Integrations : 'react-router-dom'
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Modal } from 'bootstrap';

// custom components
import { Icon } from '../../Components/Icon';
import { Chip, CustomTab, Loader, OverLay } from '../../Components/Others';
import { TextButton } from '../../Components/Buttons';
import { ConfirmModal, PreviewModal, UnlinkAccountModal } from '../../Components/Modal';

// custom style
import style from "../../Style/Component/document.module.scss";
import { APIService } from '../../Service';
import { toast } from 'react-toastify';
import { StatisticCard } from '../../Components/Card';

const TAB_TITLES = [
    { id: 1, label: 'Profile' },
    { id: 2, label: 'Documents' },
]

const NonKycDetail = () => {

    const { state } = useLocation();

    const isRendered = useRef(true);

    const navigate = useNavigate();
    const { id } = useParams();
    const [toggleMenu, setToggleMenu] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [unlinkModal, setUnlinkModal] = useState(false);

    const [blockConfirm, setBlockConfirm] = useState(false);
    const [blockStatus, setBlockStatus] = useState(false);
    const [nriDetail, setNriDetail] = useState({});

    const [confirm, setConfirm] = useState(false);
    const [status, setStatus] = useState(false);
    const [loader, setLoader] = useState(true);
    const [shortName, setShortName] = useState("");

    const [selectedTab, setSelectedTab] = useState(0);
    const [isCustomerBlocked, setIsCustomerBlocked] = useState(false);
    const [userDetailData, setUserDetailData] = useState({});
    const [profileDataLoading, setProfileDataLoading] = useState(true);

    const [userDeleteLoader, setUserDeleteLoader] = useState(false);

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        if (state !== null) {
            if (state.inner_tab_index) {
                setSelectedTab(state.inner_tab_index);
            } else {
                setSelectedTab(1);
            }
        } else {
            setSelectedTab(1);
        }
    }, [state]);

    useEffect(() => {
        if (isRendered.current === true) {
            _nriDetail();
            _userDetail();
        }
        isRendered.current = false;
    }, [])


    useEffect(() => {
        if (previewModal === true) {
            const preview_modal = new Modal(document.getElementById("preview-modal"));
            preview_modal.show();
        }
    }, [previewModal]);

    useEffect(() => {
        if (unlinkModal === true) {
            const open_modal = new Modal(document.getElementById('unlink-modal'));
            open_modal.show();
        }
    }, [unlinkModal]);

    useEffect(() => {
        if (confirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [confirm]);

    useEffect(() => {
        if (blockConfirm === true) {
            const confirm_modal = new Modal(document.getElementById('confirm-modal'));
            confirm_modal.show();
        }
    }, [blockConfirm]);

    // handle toggle activate or deactivate 
    const _handleToggleMenu = () => {
        setToggleMenu(prev => !prev);
    };

    // handle view document 
    const _handleView = () => {
        setPreviewModal(true);
    };

    // handle data delete
    const _handleDataDelete = () => {
        setConfirm(true);
        setToggleMenu(false);
    };

    // handle block customer
    const _handleBlockCustomer = () => {
        setBlockConfirm(true);
        setToggleMenu(false);
    };


    // handle tab change
    const _handleTab = (tab_id) => {
        navigate(`/non-kyc-nri/${id}`, {
            state: {
                ...state,
                inner_tab_index: tab_id,
            }
        });
    };

    // API -Nri Detail 
    const _nriDetail = () => {
        let is_post = true;
        let url = 'non-kyc-user/view';
        let request = {
            "customer_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setNriDetail(response.data);

                let updated_name = response.data.customer_summary.customer_name.split(" ");
                let short_name;

                if (updated_name.length > 1) {
                    short_name = updated_name[0].substring(0, 1) + updated_name[1].substring(0, 1)
                } else {
                    short_name = updated_name[0].substring(0, 2)
                }

                setShortName(short_name.toUpperCase());

            } else {
                navigate("/non-kyc-nri")
                toast.dismiss();
                toast.error(response.message, { type: 'error' });
            };
            setLoader(false);
        })
    };


    // API -user detail
    const _userDetail = () => {
        let is_post = true;
        let url = 'user/detail';
        let request = {
            "customer_id": Number(id)
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {

                setUserDetailData(response.data);

                setIsCustomerBlocked(response.data.profile.is_blocked);
                setProfileDataLoading(false);

            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });

                setTimeout(() => {
                    navigate(-1);
                }, 1000);
            }
        });
    };

    // API - block customer
    const _blockCustomer = () => {
        let is_post = true;
        let url = 'user/block';
        let request = {
            "customer_id": id
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setIsCustomerBlocked(response.data.is_blocked);
                setBlockStatus(true);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
        })
    };

    // API - User delete
    const _userDelete = () => {
        let is_post = true;
        let url = 'user/delete';
        let request = {
            "customer_id": id
        }
        setUserDeleteLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setStatus(true);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" });
            }
            setUserDeleteLoader(false);
        })
    };


    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                {loader || profileDataLoading ?
                    <Loader />
                    :
                    <>
                        <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                                <span className='text-decoration-hover-underline cursor-pointer'
                                    onClick={() => navigate("/non-kyc-nri")}>
                                    <Icon icon="back"
                                        size={20}
                                        className="margin-10px-right"
                                        color="#292D32" />
                                    Non KYC NRI’s</span> / <span className='e-font-weight-600'>
                                    {nriDetail.customer_summary.customer_name}
                                </span>
                            </p>
                        </div>

                        <div className='padding-52px-lr margin--80px-top'>
                            {/* Lead summary */}
                            {/* <div className={`${style.e_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-tb px-4 position-relative`}>
                                <div className='d-flex gap-4 align-items-center'>
                                    <div className='e-bg-blue-violet-light border-radius-64 p-4'>
                                        <p className='mb-0 e-text-cultured-light e-primary-font e-font-20 e-font-weight-400 line-height-24px'>
                                            {shortName}
                                        </p>
                                    </div>

                                    <div className='d-flex align-items-start gap-3'>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px'>
                                                {nriDetail.customer_summary.customer_name}
                                            </p>
                                            <a href={`mailto:${nriDetail.customer_summary.customer_email}`} target='_blank' className='mb-0 d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline'>
                                                {nriDetail.customer_summary.customer_email}
                                            </a>
                                            <a href={`tel:${nriDetail.customer_summary.customer_phone}`} className='d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline'>
                                                {nriDetail.customer_summary.customer_phone}
                                            </a>
                                        </div>
                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                DOB: <span className='e-font-weight-600'>{nriDetail.customer_summary.dob}</span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Gender: <span className='e-font-weight-600'>{nriDetail.customer_summary.gender}</span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Marital status: <span className='e-font-weight-600'>{nriDetail.customer_summary.marital_status}</span>
                                            </p>
                                        </div>
                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Occupation: <span className='e-font-weight-600'>{nriDetail.customer_summary.occupation}</span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Annual income: <span className='e-font-weight-600'>{nriDetail.customer_summary.annual_income}</span>
                                            </p>

                                        </div>

                                    </div>
                                </div>

                            </div> */}

                            <div className={`${style.e_summary_wrapper} e-bg-american-violet border-radius-16 padding-32px-tb px-4 position-relative`}>
                                <div className='d-flex gap-4 align-items-start'>
                                    <div className='e-bg-blue-violet-light border-radius-64 padding-22px-lr py-4 rounded-circle w-76px h-76px d-flex flex-column justify-content-center align-items-center'>
                                        <p className='mb-0 e-text-cultured-light e-primary-font e-font-20 e-font-weight-400 line-height-20px'>
                                            {shortName}
                                        </p>
                                    </div>

                                    {/* Basic detail of customer  */}
                                    <div className='d-flex align-items-start gap-3'>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px'>
                                                {nriDetail.customer_summary.customer_name}
                                            </p>
                                            <a href={`mailto:${nriDetail.customer_summary.customer_email}`} target='_blank' className={` mb-0 d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline`}>
                                                {nriDetail.customer_summary.customer_email}
                                            </a>
                                            <a href={`tel:${nriDetail.customer_summary.customer_phone}`} className={`d-flex e-text-platinum e-primary-font e-font-14 e-font-weight-600 line-height-18px text-decoration-none text-decoration-hover-underline`}>
                                                {/* +91 9878654567 */}
                                                {nriDetail.customer_summary.customer_phone}
                                            </a>
                                        </div>
                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Customer ID: <span className='e-font-weight-600'>
                                                    {userDetailData.profile?.customer_id ? userDetailData.profile?.customer_id : "-"}
                                                </span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Resident Type: <span className='e-font-weight-600'>
                                                    {userDetailData.profile?.resident_type || "-"}
                                                </span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Global rebalance opt-out: <span className='e-font-weight-600'>{userDetailData.customer_summary?.global_rebalance_opt_out === true ? "Yes" : "No"}</span>
                                            </p>
                                        </div>
                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px '>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                RM name: <span className='e-font-weight-600'>
                                                    {userDetailData.customer_summary?.rm_name || "-"}
                                                </span>
                                            </p>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                RM code: <span className='e-font-weight-600'>
                                                    {userDetailData.customer_summary?.rm_code || "-"}
                                                </span>
                                            </p>

                                        </div>

                                        <div className='vr e-bg-lavender-blue'></div>
                                        <div className='d-flex flex-column gap-12px'>
                                            <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                Risk Appetite: <span className='e-font-weight-600'>
                                                    {userDetailData.profile?.risk_appetite || "-"}
                                                </span>
                                            </p>
                                            <div className='d-flex align-items-center gap-1'>
                                                <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                    KYC Completed Via:
                                                </p>

                                                <Chip type={2}
                                                    dotClass="e-bg-green-crayola"
                                                    label={userDetailData.profile?.kyc_completed_via} />
                                            </div>

                                            <div className='d-flex align-items-center gap-1'>
                                                <p className='mb-0 e-text-platinum e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                                    Account Creation:
                                                </p>
                                                <Chip type={2}
                                                    dotClass={userDetailData.profile?.account_creation_status === "In progress" ? "e-bg-marigold" : "e-bg-green-crayola"}
                                                    label={userDetailData.profile?.account_creation_status} />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Toggle menu  */}
                                <>
                                    <Icon icon="menu"
                                        size="1.5rem"
                                        height="1.375rem"
                                        color="#FFFFFF"
                                        className="position-absolute right-32px top-16px cursor-pointer"
                                        onClick={_handleToggleMenu} />

                                    {toggleMenu &&
                                        <>
                                            <OverLay isOpen={toggleMenu} onClose={_handleToggleMenu} />
                                            <div className={`${style.e_menu_popup} e-bg-white border-radius-8 position-absolute right-32px top-48px padding-10px-tb padding-12px-lr d-flex gap-20px flex-column z-index-99`}>
                                                <div className='d-flex gap-1 cursor-pointer align-items-center '
                                                    onClick={_handleBlockCustomer}>
                                                    <img src={require("../../Assets/Image/Others/deactivate.svg").default}
                                                        draggable={false}
                                                        alt='block' />

                                                    <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px'>
                                                        {isCustomerBlocked === true ? 'Unblock Customer' : 'Block Customer'}
                                                    </p>
                                                </div>
                                                <div className='d-flex gap-1 cursor-pointer align-items-center'
                                                    onClick={_handleDataDelete}>
                                                    <img src={require("../../Assets/Image/Others/delete.svg").default}
                                                        draggable={false}
                                                        alt='delete' />

                                                    <p className='mb-0 e-text-raisin-black e-primary-font e-font-12 e-font-weight-600 line-height-16px'>
                                                        Data Delete Request
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    }
                                </>

                                {/* Statistic cards */}
                                <div className='row row-cols-4 row-gap-4 pt-4'>
                                    <div className='col'>
                                        <StatisticCard title="Amount invested"
                                            value={userDetailData.customer_summary.total_amount_invested || "-"}
                                        />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="Total returns"
                                            value={userDetailData.customer_summary.total_returns_text || "-"}
                                        />
                                    </div>
                                    <div className='col'>
                                        <StatisticCard title="XIRR"
                                            value={userDetailData.customer_summary.xirr || "-"}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Custom tab */}
                            <div className='d-flex py-4 mt-2'>
                                <CustomTab data={TAB_TITLES}
                                    flexGap="gap-2"
                                    selectedTab={selectedTab}
                                    tooltip={false}
                                    handleClick={_handleTab} />
                            </div>

                            <div className={`${style.e_data_wrapper} e-bg-ghost-white border-radius-16 padding-32px-all min-vh-50`}>
                                {selectedTab === 1 ?
                                    <div className='d-flex flex-column gap-4 '>
                                        {/* User details */}
                                        <div>
                                            <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                User details
                                            </h6>

                                            <div className='e-bg-magnolia border-radius-8 p-3 '>
                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Salutation
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Full name
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile.name || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            DOB
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile.dob || "-"}
                                                        </p>
                                                    </div>

                                                </div>

                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Gender
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile.gender || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Marital status
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile.marital_status || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Citizenship
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.kyc_details.citizenship || "-"}
                                                        </p>
                                                    </div>

                                                </div>

                                                <div className='pb-4 row'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Residential Status
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile.resident_type || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Email
                                                        </p>
                                                        <a href={`mailto:${userDetailData.profile.email}`} target='_blank' className={`mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px text-decoration-none text-decoration-hover-underline`}>
                                                            {userDetailData.profile.email || "-"}
                                                        </a>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Email ID belongs to
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>

                                                </div>

                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Phone number
                                                        </p>
                                                        <a href={`tel:${userDetailData.profile.phone}`} className={`mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px text-decoration-none text-decoration-hover-underline`}>
                                                            {userDetailData.profile.phone || "-"}
                                                        </a>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Mobile Number belongs to
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Occupation
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile.occupation || "-"}
                                                        </p>
                                                    </div>

                                                </div>

                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Father/Spouse
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Father/Spouse Name
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Father/Spouse Salutation
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Mother’s Name
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Indian address details */}
                                        <div>
                                            <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                Indian address details
                                            </h6>

                                            <div className='e-bg-magnolia border-radius-8 p-3 '>
                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Address type
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className='row pb-4'>
                                                    <div className='col-12'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Address
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {
                                                                (() => {
                                                                    const updated_address = userDetailData?.kyc_details?.permanent_address;
                                                                    if (!updated_address) return "-";

                                                                    const parts = [
                                                                        `${updated_address.address_line1 || ""} ${updated_address.address_line2 || ""}`.trim(),
                                                                        updated_address.city || "",
                                                                        updated_address.state || "",
                                                                        updated_address.pincode || ""
                                                                    ];

                                                                    return parts.filter(Boolean).join(", ");
                                                                })()
                                                            }
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            State
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData?.kyc_details?.permanent_address?.state || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            City
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData?.kyc_details?.permanent_address?.city || "-"}
                                                        </p>
                                                    </div>

                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            District
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            -
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Pincode
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.kyc_details?.permanent_address?.pincode || "-"}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* KYC details */}
                                        {/* <div>
                                            <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                KYC details
                                            </h6>

                                            <div className='e-bg-magnolia border-radius-8 p-3'>
                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            PAN
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.kyc_details.pan || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Nationality
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.kyc_details.citizenship || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            City
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.kyc_details.city || "-"}
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className='row pb-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            State
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.kyc_details.state || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-5'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Permanent address
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                                            {
                                                                (() => {
                                                                    const updated_address = userDetailData?.kyc_details?.permanent_address;
                                                                    if (!updated_address) return "-";

                                                                    const parts = [
                                                                        `${updated_address.address_line1 || ""} ${updated_address.address_line2 || ""}`.trim(),
                                                                        updated_address.city || "",
                                                                        updated_address.state || "",
                                                                        updated_address.pincode || ""
                                                                    ];

                                                                    return parts.filter(Boolean).join(", ");
                                                                })()
                                                            }
                                                        </p>
                                                    </div>
                                                </div>

                                                {userDetailData.kyc_details.is_same_corresponding_address === false &&
                                                    <div className='row'>
                                                        <div className='col-5'>
                                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                Communication address
                                                            </p>
                                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                                                {
                                                                    (() => {
                                                                        const updated_address = userDetailData?.kyc_details?.correspondence_address;
                                                                        if (!updated_address) return "-";

                                                                        const parts = [
                                                                            `${updated_address.address_line1 || ""} ${updated_address.address_line2 || ""}`.trim(),
                                                                            updated_address.city || "",
                                                                            updated_address.state || "",
                                                                            updated_address.pincode || ""
                                                                        ];

                                                                        return parts.filter(Boolean).join(", ");
                                                                    })()
                                                                }
                                                            </p>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div> */}

                                        {/* Financial details */}
                                        <div>
                                            <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                Financial details
                                            </h6>

                                            <div className='e-bg-magnolia border-radius-8 p-3 '>
                                                <div className='row row-gap-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Gross Annual Income
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            -
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Source of Fund
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile?.income_source || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Nature of Business / Profession
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {userDetailData.profile?.occupation || "-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Individual Type
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            -
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Nominee details */}
                                        <div>
                                            <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                Nominee details
                                            </h6>

                                            {userDetailData.nominee?.length > 0 ?
                                                <div className='d-flex flex-column gap-2'>
                                                    {userDetailData.nominee && userDetailData.nominee.map((nominee) => (
                                                        <div className='e-bg-magnolia border-radius-8 p-3'>
                                                            <div className='e-border-1px-bottom pb-4'>
                                                                <div className='row row-gap-4'>
                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            Nominee Name
                                                                        </p>
                                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                            {nominee.name || "-"}
                                                                        </p>
                                                                    </div>
                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            Nominee Relationship
                                                                        </p>
                                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                            {nominee.relation || "-"}
                                                                        </p>
                                                                    </div>
                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            DOB
                                                                        </p>
                                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                            {nominee.dob || "-"}
                                                                        </p>
                                                                    </div>
                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            Allocation (%)
                                                                        </p>
                                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                            {nominee.allocation || '-'}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='e-border-1px-bottom pb-4'>
                                                                <div className='row row-gap-4 pt-4'>
                                                                    <div className='col-12'>
                                                                        <h6 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                                            Identity Details
                                                                        </h6>
                                                                    </div>

                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            Identity Document Number
                                                                        </p>
                                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                            {"-"}
                                                                        </p>
                                                                    </div>

                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            Identity Document Type
                                                                        </p>
                                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                            {"-"}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='e-border-1px-bottom pb-4'>
                                                                <div className='row row-gap-4 pt-4'>
                                                                    <div className='col-12'>
                                                                        <h6 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                                            Contact Details
                                                                        </h6>
                                                                    </div>

                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            Phone Number
                                                                        </p>
                                                                        <a href={`tel:${nominee.phone}`} className={`mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px text-decoration-none text-decoration-hover-underline`}>
                                                                            {nominee.phone || "-"}
                                                                        </a>
                                                                    </div>

                                                                    <div className='col-4'>
                                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                            Email Address
                                                                        </p>
                                                                        <a href={`mailto:${nominee.email}`} target='_blank' className={`mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px text-decoration-none text-decoration-hover-underline`}>
                                                                            {nominee.email || "-"}
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className='row row-gap-4 pt-4'>
                                                                <div className='col-12'>
                                                                    <h6 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                                        Address Details
                                                                    </h6>
                                                                </div>

                                                                <div className='col-12'>
                                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                        Address
                                                                    </p>
                                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                        {"-"}
                                                                    </p>
                                                                </div>

                                                                <div className='col-4'>
                                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                        State
                                                                    </p>
                                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                        {"-"}
                                                                    </p>
                                                                </div>

                                                                <div className='col-4'>
                                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                        City
                                                                    </p>
                                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                        {"-"}
                                                                    </p>
                                                                </div>

                                                                <div className='col-4'>
                                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                        District
                                                                    </p>
                                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                        {"-"}
                                                                    </p>
                                                                </div>

                                                                <div className='col-4'>
                                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                        Pincode
                                                                    </p>
                                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                        {"-"}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                    }
                                                </div>
                                                :
                                                <div className='e-bg-magnolia border-radius-8 p-5'>
                                                    <div className='row  '>
                                                        <div className='justify-content-center  align-items-center d-flex e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>No data found</div>
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        {/* FATCA */}
                                        <div>
                                            <h6 className='mb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                                FATCA
                                            </h6>
                                            <div className='e-bg-magnolia border-radius-8 p-3'>

                                                <div className='e-border-1px-bottom pb-4'>
                                                    <div className='row row-gap-4'>
                                                        <div className='col-4'>
                                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                Place of Birth - Country
                                                            </p>
                                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                {"-"}
                                                            </p>
                                                        </div>
                                                        <div className='col-4'>
                                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                Place of Birth - State
                                                            </p>
                                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                {"-"}
                                                            </p>
                                                        </div>
                                                        <div className='col-4'>

                                                        </div>

                                                        <div className='col-4'>
                                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                Are you a tax resident of any country other than India?
                                                            </p>
                                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                {"-"}
                                                            </p>
                                                        </div>
                                                        <div className='col-4'>
                                                            <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                                Country of Tax Residency
                                                            </p>
                                                            <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                                {"-"}
                                                            </p>
                                                        </div>


                                                    </div>
                                                </div>

                                                <div className='row pt-4'>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            Identification Type
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                    <div className='col-4'>
                                                        <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                            TIN Number
                                                        </p>
                                                        <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-24px'>
                                                            {"-"}
                                                        </p>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <h4 className='mb-4 pb-3 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                                            Documents
                                        </h4>


                                        <div className='e-border-1px-bottom pb-3 '>
                                            <div className='d-flex gap-40px align-items-end'>
                                                <div>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        PAN number
                                                    </p>
                                                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-20px'>
                                                        {nriDetail.documents[0]?.pan ? nriDetail.documents[0]?.pan : '-'}
                                                    </p>
                                                    {nriDetail.documents[0]?.pan_image &&
                                                        <div className='mt-1 pt-2'>
                                                            {/* <img src={nriDetail.documents[0]?.pan_image}
                                                            draggable={false}
                                                            width={182}
                                                            height={112}
                                                            className={style.e_document_wrapper}
                                                            alt='pan' /> */}

                                                            {(() => {
                                                                const url = nriDetail.documents[0]?.pan_image;
                                                                const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                    url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                return isPDF ? (
                                                                    <iframe
                                                                        src={url}
                                                                        width={282}
                                                                        height={222}
                                                                        className={style.e_document_wrapper}
                                                                        title='Pan'
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={url}
                                                                        draggable={false}
                                                                        width={182}
                                                                        height={112}
                                                                        className={style.e_document_wrapper}
                                                                        alt='Pan'
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                    }

                                                </div>


                                                {
                                                    nriDetail.documents[0]?.pan_image &&
                                                    <div className='cursor-pointer'
                                                        onClick={() => window.open(nriDetail.documents[0]?.pan_image)}>

                                                        <span className='ps-2 e-text-blue-violet e-primary-font e-font-16 e-font-weight-600 line-height-16px'>
                                                            Download/Preview
                                                        </span>
                                                    </div>
                                                }

                                            </div>


                                            {/* <div className='d-flex align-items-center gap-32px pt-4 px-2'>
                                            <TextButton name="View"
                                                onClick={_handleView} />
                                            <TextButton name="Download" />
                                        </div> */}
                                        </div>

                                        <div className='e-border-1px-bottom py-3 '>
                                            <div className='d-flex gap-40px align-items-end'>
                                                <div>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Photo
                                                    </p>
                                                    {nriDetail.documents[0]?.profile_image &&
                                                        <div className='mt-1 pt-2'>

                                                            {(() => {
                                                                const url = nriDetail.documents[0]?.profile_image;
                                                                const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                    url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                return isPDF ? (
                                                                    <iframe
                                                                        src={url}
                                                                        width={282}
                                                                        height={222}
                                                                        className={style.e_document_wrapper}
                                                                        title='Profile'
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={url}
                                                                        draggable={false}
                                                                        width={182}
                                                                        height={112}
                                                                        className={style.e_document_wrapper}
                                                                        alt='Profile'
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                    }

                                                </div>


                                                {
                                                    nriDetail.documents[0]?.profile_image &&
                                                    <div className='cursor-pointer'
                                                        onClick={() => window.open(nriDetail.documents[0]?.profile_image)}>

                                                        <span className='ps-2 e-text-blue-violet e-primary-font e-font-16 e-font-weight-600 line-height-16px'>
                                                            Download/Preview
                                                        </span>
                                                    </div>
                                                }

                                            </div>
                                        </div>


                                        {/* address_proof_url */}

                                        <div className='e-border-1px-bottom py-3 '>
                                            <div className='d-flex gap-40px align-items-end'>
                                                <div>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Address proof
                                                    </p>

                                                    {nriDetail.documents[0]?.address_proof_url ?
                                                        <div className='mt-1 pt-2'>

                                                            {(() => {
                                                                const url = nriDetail.documents[0]?.address_proof_url;
                                                                const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                    url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                return isPDF ? (
                                                                    <iframe
                                                                        src={url}
                                                                        width={282}
                                                                        height={222}
                                                                        className={style.e_document_wrapper}
                                                                        title='address proof'
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={url}
                                                                        draggable={false}
                                                                        width={182}
                                                                        height={112}
                                                                        className={style.e_document_wrapper}
                                                                        alt='address proof'
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                        :
                                                        "-"
                                                    }

                                                </div>

                                                {nriDetail.documents[0]?.address_proof_url &&
                                                    <div className='cursor-pointer'
                                                        onClick={() => window.open(nriDetail.documents[0]?.address_proof_url)}>

                                                        <span className='ps-2 e-text-blue-violet e-primary-font e-font-16 e-font-weight-600 line-height-16px'>
                                                            Download/Preview
                                                        </span>
                                                    </div>
                                                }

                                            </div>
                                        </div>



                                        {/* bank_proof */}
                                        <div className='e-border-1px-bottom py-3 '>
                                            <div className='d-flex gap-40px align-items-end'>
                                                <div>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Bank proof
                                                    </p>

                                                    {nriDetail.documents[0]?.bank_proof ?
                                                        <div className='mt-1 pt-2'>
                                                            {(() => {
                                                                const url = nriDetail.documents[0]?.bank_proof;
                                                                const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                    url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                return isPDF ? (
                                                                    <iframe
                                                                        src={url}
                                                                        width={282}
                                                                        height={222}
                                                                        className={style.e_document_wrapper}
                                                                        title='bank proof'
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={url}
                                                                        draggable={false}
                                                                        width={182}
                                                                        height={112}
                                                                        className={style.e_document_wrapper}
                                                                        alt='bank proof'
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                        :
                                                        "-"
                                                    }
                                                </div>
                                                {nriDetail.documents[0]?.bank_proof &&
                                                    <div className='cursor-pointer'
                                                        onClick={() => window.open(nriDetail.documents[0]?.bank_proof)}>

                                                        <span className='ps-2 e-text-blue-violet e-primary-font e-font-16 e-font-weight-600 line-height-16px'>
                                                            Download/Preview
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>


                                        {/* identity_proof */}
                                        <div className='e-border-1px-bottom py-3 '>
                                            <div className='d-flex gap-40px align-items-end'>
                                                <div>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Identity proof
                                                    </p>

                                                    {nriDetail.documents[0]?.identity_proof ?
                                                        <div className='mt-1 pt-2'>
                                                            {(() => {
                                                                const url = nriDetail.documents[0]?.identity_proof;
                                                                const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                    url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                return isPDF ? (
                                                                    <iframe
                                                                        src={url}
                                                                        width={282}
                                                                        height={222}
                                                                        className={style.e_document_wrapper}
                                                                        title='Identity proof'
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={url}
                                                                        draggable={false}
                                                                        width={182}
                                                                        height={112}
                                                                        className={style.e_document_wrapper}
                                                                        alt='Identity proof'
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                        :
                                                        "-"
                                                    }
                                                </div>
                                                {nriDetail.documents[0]?.identity_proof &&
                                                    <div className='cursor-pointer'
                                                        onClick={() => window.open(nriDetail.documents[0]?.identity_proof)}>

                                                        <span className='ps-2 e-text-blue-violet e-primary-font e-font-16 e-font-weight-600 line-height-16px'>
                                                            Download/Preview
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        {/* sign_proof */}
                                        <div className='e-border-1px-bottom py-3 '>
                                            <div className='d-flex gap-40px align-items-end'>
                                                <div>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Sign
                                                    </p>

                                                    {nriDetail.documents[0]?.sign_proof ?
                                                        <div className='mt-1 pt-2'>
                                                            {(() => {
                                                                const url = nriDetail.documents[0]?.sign_proof;
                                                                const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                    url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                return isPDF ? (
                                                                    <iframe
                                                                        src={url}
                                                                        width={282}
                                                                        height={222}
                                                                        className={style.e_document_wrapper}
                                                                        title='Sign proof'
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={url}
                                                                        draggable={false}
                                                                        width={182}
                                                                        height={112}
                                                                        className={style.e_document_wrapper}
                                                                        alt='Sign proof'
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                        :
                                                        "-"
                                                    }
                                                </div>
                                                {nriDetail.documents[0]?.sign_proof &&
                                                    <div className='cursor-pointer'
                                                        onClick={() => window.open(nriDetail.documents[0]?.sign_proof)}>

                                                        <span className='ps-2 e-text-blue-violet e-primary-font e-font-16 e-font-weight-600 line-height-16px'>
                                                            Download/Preview
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        {/* passport_image */}
                                        <div className='e-border-1px-bottom py-3 '>
                                            <div className='d-flex gap-40px align-items-end'>
                                                <div>
                                                    <p className='mb-2 e-text-dark-silver e-primary-font e-font-14 e-font-weight-400 line-height-16px'>
                                                        Passport
                                                    </p>

                                                    {nriDetail.documents[0]?.passport_image ?
                                                        <div className='mt-1 pt-2'>
                                                            {(() => {
                                                                const url = nriDetail.documents[0]?.passport_image;
                                                                const isPDF = url.toLowerCase().includes('.pdf') ||
                                                                    url.split('?')[0].toLowerCase().endsWith('.pdf')

                                                                return isPDF ? (
                                                                    <iframe
                                                                        src={url}
                                                                        width={282}
                                                                        height={222}
                                                                        className={style.e_document_wrapper}
                                                                        title='passport'
                                                                    />
                                                                ) : (
                                                                    <img
                                                                        src={url}
                                                                        draggable={false}
                                                                        width={182}
                                                                        height={112}
                                                                        className={style.e_document_wrapper}
                                                                        alt='passport'
                                                                    />
                                                                );
                                                            })()}
                                                        </div>
                                                        :
                                                        "-"
                                                    }
                                                </div>
                                                {nriDetail.documents[0]?.passport_image &&
                                                    <div className='cursor-pointer'
                                                        onClick={() => window.open(nriDetail.documents[0]?.passport_image)}>

                                                        <span className='ps-2 e-text-blue-violet e-primary-font e-font-16 e-font-weight-600 line-height-16px'>
                                                            Download/Preview
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                        </div>
                    </>
                }
            </section>

            {/* Document preview modal */}
            {previewModal === true &&
                <PreviewModal type={2}
                    title="View document"
                    button={false}
                    handleClose={() => {
                        setTimeout(() => {
                            setPreviewModal(false);
                        }, 200);
                    }} />
            }

            {/* Unlink account modal */}
            {unlinkModal === true &&
                <UnlinkAccountModal
                    handleClose={() => {
                        setTimeout(() => {
                            setUnlinkModal(false);
                        }, 200);
                    }}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setUnlinkModal(false);
                        }, 200);
                    }} />
            }

            {/* confirm block customer modal */}
            {blockConfirm === true &&
                <ConfirmModal title={blockStatus ? "Confirm successfully" : isCustomerBlocked === true ? "Unblock user confirmation" : "Block user confirmation"}
                    description={blockStatus ? isCustomerBlocked === true ? "The customer blocked successfully." : "The customer Unblocked successfully." : isCustomerBlocked === true ? "You are about Unblock this user. This action will grant them access. Are you sure want to proceed?" : "You are about block this user. This action will revoke their access. Are you sure want to proceed?"}
                    status={blockStatus}
                    handleClose={() => {
                        setTimeout(() => {
                            setBlockConfirm(false);
                            setBlockStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() => {
                        _blockCustomer();
                    }
                    }
                    handleSuccess={() => {
                        setTimeout(() => {
                            setBlockConfirm(false);
                            setBlockStatus(false);
                            setToggleMenu(false);
                        }, 200);
                    }} />
            }

            {/* confirm delete data modal */}
            {confirm === true &&
                <ConfirmModal title={status ? "Confirm successfully" : "Confirm data delete request"}
                    description={status ? "The data deleted successfully." : " This action will initiate the data deletion process for this customer. Please ensure all documentation is reviewed and compliant with data policies before proceeding."}
                    status={status}
                    loader={userDeleteLoader}
                    handleClose={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                        }, 200);
                    }}
                    handleConfirm={() => _userDelete()}
                    handleSuccess={() => {
                        setTimeout(() => {
                            setConfirm(false);
                            setStatus(false);
                            setToggleMenu(false);
                            navigate("/non-kyc-nri");
                        }, 200);
                    }} />
            }
        </Fragment>

    )
}

export default NonKycDetail;
